module.exports = __webpack_public_path__ + "static/item-4-55776658edec3aa3a12edc229c95d686.png";